import { Chevron } from '@components/icons/chevron'
import { useOnboarding } from '@lib/hooks/useOnboarding'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'

import styles from './header.module.scss'

export const Header = observer(() => {
    const onboarding = useOnboarding()

    return (
        <div className={classNames(styles.header)}>
            <div
                className={classNames(
                    styles.action,
                    !onboarding.isHeaderBackButtonVisible && styles.hidden,
                )}
            >
                <button
                    onClick={async () => {
                        await onboarding.backButtonFn?.()
                    }}
                >
                    <Chevron width='20px' direction='left' color='step-white' />
                </button>
            </div>
            <div className={styles.headerTextContainer}>
                <h1>{onboarding.headerText}</h1>
            </div>
            <div
                className={classNames(
                    styles.action,
                    !onboarding.isHeaderActionButtonVisible && styles.hidden,
                )}
            />
        </div>
    )
})

export default Header
